import { ETabBarSegments } from '~/modules/tabBar/enums/ETabBarSegments';

import type { EIcon } from '~/enums/EIcon';

export interface IRouteItem {
  path: string;
  segment: TAllowedSegments;
  code: string | null;
  scrollYTop: number;
  values?: IRouteItem[];
}

export interface INavigateItem {
  name: string;
  segment: ETabBarSegments;
  icon: EIcon.TImageKey;
  value?: string | number;
  method?: () => void;
}

export type TProductSegment = 'product';
export type TCheckoutSegment = 'checkout';
export type TSearchSegment = 'search';
export type TInfoSegment = 'info';
export type TAboutSegment = 'about';
export type THelpSegment = 'help';
export type TAllowedSegments = ETabBarSegments | TProductSegment | TCheckoutSegment | TSearchSegment | TInfoSegment | TAboutSegment | THelpSegment;
export type TSegmentedHistory = Record<ETabBarSegments, IRouteItem>;

export const PRODUCT_SEGMENT: TProductSegment = 'product';
export const CHECKOUT_SEGMENT: TCheckoutSegment = 'checkout';
export const SEARCH_SEGMENT: TSearchSegment = 'search';
export const INFO_SEGMENT: TInfoSegment = 'info';
export const ABOUT_SEGMENT: TAboutSegment = 'about';
export const HELP_SEGMENT: THelpSegment = 'help';

export const NAVIGATE_ITEMS: INavigateItem[] = [
  {
    name: 'Каталог',
    segment: ETabBarSegments.Catalog,
    icon: 'Search224',
  },
  {
    name: 'Избранное',
    segment: ETabBarSegments.Favorites,
    icon: 'Heart24',
  },
  {
    name: 'Главная',
    segment: ETabBarSegments.Home,
    icon: 'Logo24',
  },
  {
    name: 'Профиль',
    segment: ETabBarSegments.Cabinet,
    icon: 'User24',
  },
  {
    name: 'Корзина',
    segment: ETabBarSegments.Cart,
    icon: 'Cart24',
  },
];

export const BASIC_SEGMENT_DATA: TSegmentedHistory = {
  [ETabBarSegments.Catalog]: {
    path: '/catalog/menu/',
    segment: ETabBarSegments.Catalog,
    code: '',
    scrollYTop: 0,
    values: [],
  },
  [ETabBarSegments.Home]: {
    path: '/',
    segment: ETabBarSegments.Home,
    code: '',
    scrollYTop: 0,
    values: [],
  },
  [ETabBarSegments.Cabinet]: {
    path: '/cabinet/',
    segment: ETabBarSegments.Cabinet,
    code: '',
    scrollYTop: 0,
    values: [],
  },
  [ETabBarSegments.Favorites]: {
    path: '/favorites/',
    segment: ETabBarSegments.Favorites,
    code: '',
    scrollYTop: 0,
    values: [],
  },
  [ETabBarSegments.Cart]: {
    path: '/cart/',
    segment: ETabBarSegments.Cart,
    code: '',
    scrollYTop: 0,
    values: [],
  },
  [ETabBarSegments.UnUsed]: {
    path: '/',
    segment: ETabBarSegments.UnUsed,
    code: '',
    scrollYTop: 0,
    values: [],
  },
};

export { ETabBarSegments };
